import { Component } from '@angular/core';

/** Tab root for the project-level MGVW tab (sits next to Diaries). */
@Component({
  selector: 'app-mgvw-records-wrapper',
  templateUrl: './mgvw-records-wrapper.component.html',
  styleUrls: ['./mgvw-records-wrapper.component.scss'],
  standalone: false,
})
export class MgvwRecordsWrapperComponent {}
